import { Tooltip } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { UIMyChallenges } from 'types';
import ChallengeCardCTA from './ChallengeCardCTA';
import classNames from 'classnames';
interface MeetingProps {
	challenge: UIMyChallenges;
	onStart?: () => void;
	isHorizontalLayout?: boolean;
}

const ChallengeCard = ({ challenge, isHorizontalLayout }: MeetingProps) => {
	const [maxLength, setMaxLength] = useState<number>(15);

	useEffect(() => {
		if (window.innerWidth < 960) {
			setMaxLength(15);
		} else {
			setMaxLength(28);
		}
	}, []);

	return (
		<>
			<div
				// add a bg image /assets/prep-card-bg-image.svg
				// style={{
				// 	backgroundImage: `url(/assets/prep-card-bg-image.svg) lightgray 50% / cover no-repeat`,
				// }}
				className={
					isHorizontalLayout
						? ``
						: ` border border-[#E2E8F0] dark:border-[#3F3F3F] rounded-[8px] bg-white dark:bg-[#1F2A37] relative isolate`
				}
			>
				{isHorizontalLayout ? null : (
					<div>
						<div className="absolute h-full w-full z-[-1] rounded-[8px] [background:_linear-gradient(242.84deg,_rgba(255,_255,_255,_0)_6.73%,_#FFFFFF_42.5%)] dark:[background:_linear-gradient(230.66deg,_rgba(31,_42,_55,_0)_0%,_#1F2A37_40.77%)]"></div>
						<img
							src={`/assets/prep-card-bg-image.svg`}
							alt="challenge"
							className="absolute w-full h-full rounded-[8px] z-[-2] dark:mix-blend-color-burn"
						/>
					</div>
				)}
				<div
					className={isHorizontalLayout ? `flex gap-[12px]` : `pt-[16px] px-[16px] pb-[8px] flex flex-col items-center`}
				>
					<img src={challenge.logo} alt={challenge.title} className="w-[72px] h-[72px]" />
					<div>
						<p
							className={classNames(
								'relative text-[16px] font-[600] leading-[20px] font-inter dark:text-[#FFF] text-left max-w-fit',
								isHorizontalLayout ? '' : 'mt-[8px]',
							)}
						>
							{challenge.title.length > maxLength ? (
								<>
									<Tooltip
										onClick={e => {
											e.stopPropagation();
										}}
										content={challenge.title}
									>
										<span
											onClick={e => {
												e.stopPropagation();
											}}
										>
											{challenge.title.substring(0, maxLength)}...
										</span>
									</Tooltip>
								</>
							) : (
								<>{challenge.title}</>
							)}
						</p>
						{isHorizontalLayout && <ChallengeCardCTA isHorizontalLayout={isHorizontalLayout} challenge={challenge} />}
					</div>
				</div>
				{!isHorizontalLayout && <ChallengeCardCTA challenge={challenge} />}
			</div>
		</>
	);
};

export default ChallengeCard;
